import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { organizationTypeQuerySchema } from './organization-type-query-schema';

export const organizationTypeFormSchema = organizationTypeQuerySchema
  .omit({ name: true, status: true, plural: true, clients_count: true })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    plural: z.string(),
  });
export type OrganizationTypeFormSchema = z.infer<typeof organizationTypeFormSchema>;
